import queryString from 'query-string'
import { pick, has } from 'lodash'
import { makeRequest } from '../base/axios.ts'

// returns a new object containing only the keys we would like to persist to the server
function _extractServerAttributes(timelineAttributes) {
  let attributes = pick(timelineAttributes, [
    'title',
    'description',
    'publish_status_code',
    'access_level',
    'category_ids',
    'photo_ids',
  ])
  // remove category_ids if it's empty, Rails will complain
  if (has(attributes, 'category_ids')) {
    if (
      attributes.category_ids === undefined ||
      attributes.category_ids === null ||
      attributes.category_ids.length === 0
    ) {
      delete attributes.category_ids
    }
  }

  // remove any photos with id 0, this signifies an empty image
  if (has(attributes, 'photo_ids')) {
    if (attributes.photo_ids[0] === 0) {
      throw new Error("Photo has id of 0. Don't send that to api or it'll 404")
    }
  }
  return attributes
}

export default {
  fetchTimelines: function (page = 1, mode = 'account', type = 'grid') {
    const url = queryString.stringifyUrl({
      url: `/api/v1/timelines`,
      query: {
        // Stringifying as nesting isn't supported. See https://github.com/sindresorhus/query-string?tab=readme-ov-file#nesting
        filters: JSON.stringify({
          visibility: mode,
        }),
        page,
        type,
      },
    })

    return makeRequest({
      url,
      method: 'get',
      requestId: `load-${mode}-timelines-page-${page}-as-${type}`,
    })
  },

  fetchGroupTimelines: function (page, groupId) {
    const url = queryString.stringifyUrl({
      url: `/api/v1/groups/${groupId}/timelines`,
      query: {
        type: 'grid',
        page,
      },
    })
    return makeRequest({
      url,
      method: 'get',
      requestId: `load-group-timelines--group-${groupId}-page-${page}`,
    })
  },

  // returns a promise if no pending requests
  createTimeline: function (timelineAttributes) {
    const data = {
      timeline: _extractServerAttributes(timelineAttributes),
    }
    return makeRequest({
      url: '/api/v1/timelines',
      method: 'post',
      data,
      requestId: 'post-timelines',
    })
  },

  updateTimeline: function (timelineAttributes) {
    return makeRequest({
      url: `/api/v1/timelines/${timelineAttributes.id}`,
      method: 'put',
      data: {
        timeline: _extractServerAttributes(timelineAttributes),
      },
      requestId: `put-timeline-${timelineAttributes.id}`,
    })
  },
}
